
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-events/[uid]",
      function () {
        return require("private-next-pages/customer-events/[uid].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-events/[uid]"])
      });
    }
  